import { render, staticRenderFns } from "./GitFlowDetail.vue?vue&type=template&id=72a221a0&"
import script from "./GitFlowDetail.vue?vue&type=script&lang=js&"
export * from "./GitFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./GitFlowDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports